import CRCE_Award from '../images/painterPage/CRCE_Champion_of_Innovation.JPG';

const awards = [

    {
        img: CRCE_Award,
        alt: "CRCE Award Certificate",
        title: "Champion of Innovation in Construction Robot Competition And Exhibition 2025"
    }
];

export default awards;